var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { MEDIA_QUERIES } from 'shared/style';
import { transformErrorToObject } from 'shared/error';
import Loading from 'components/shared/Loading';
import Error from 'components/shared/Error';
import { GET_COMMENTS } from '.';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n\n  > form {\n    > ul {\n      > li {\n        float: left;\n        height: 100px;\n      }\n\n      > .content {\n        ", " {\n          width: calc(100% - 100px);\n        }\n        ", " {\n          width: calc(100% - 80px);\n        }\n\n        > textarea {\n          all: unset;\n          box-sizing: border-box;\n          width: 100%;\n          height: 100%;\n          border: 1px solid #36c;\n          padding: 20px;\n          font-size: 20px;\n        }\n      }\n\n      > .button, .button-2 {\n        ", " {\n          width: 90px;\n        }\n        ", " {\n          width: 70px;\n        }\n        margin-left: 10px;\n\n        > button {\n          all: unset;\n          box-sizing: border-box;\n          width: 100%;\n          text-align: center;\n          color: #fff;\n          font-size: 14px;\n          cursor: pointer;\n        }\n\n        > .write {\n          background-color: #36c;\n        }\n\n        > .cancel {\n          background-color: #f00;\n        }\n      }\n\n      > .button > button {\n        height: 100%;\n      }\n\n      > .button-2 > button {\n        height: 50%;\n      }\n    }\n\n    > .error {\n      width: 100%;\n      ", " {\n        padding-left: 75px;\n      }\n      color: red;\n    }\n  }\n"], ["\n  width: 100%;\n\n  > form {\n    > ul {\n      > li {\n        float: left;\n        height: 100px;\n      }\n\n      > .content {\n        ", " {\n          width: calc(100% - 100px);\n        }\n        ", " {\n          width: calc(100% - 80px);\n        }\n\n        > textarea {\n          all: unset;\n          box-sizing: border-box;\n          width: 100%;\n          height: 100%;\n          border: 1px solid #36c;\n          padding: 20px;\n          font-size: 20px;\n        }\n      }\n\n      > .button, .button-2 {\n        ", " {\n          width: 90px;\n        }\n        ", " {\n          width: 70px;\n        }\n        margin-left: 10px;\n\n        > button {\n          all: unset;\n          box-sizing: border-box;\n          width: 100%;\n          text-align: center;\n          color: #fff;\n          font-size: 14px;\n          cursor: pointer;\n        }\n\n        > .write {\n          background-color: #36c;\n        }\n\n        > .cancel {\n          background-color: #f00;\n        }\n      }\n\n      > .button > button {\n        height: 100%;\n      }\n\n      > .button-2 > button {\n        height: 50%;\n      }\n    }\n\n    > .error {\n      width: 100%;\n      ", " {\n        padding-left: 75px;\n      }\n      color: red;\n    }\n  }\n"])), MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE, MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE, MEDIA_QUERIES.PC_TABLET);
var GET_USER = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  {\n    currentUser {\n      id\n    }\n  }\n"], ["\n  {\n    currentUser {\n      id\n    }\n  }\n"])));
var WRITE_COMMENT = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mutation WriteComment($comment: WritingCommentPayload!) {\n    comment: writeComment(comment: $comment) {\n      id\n      author {\n        id\n        name\n        role\n      }\n      createdAt\n      updatedAt\n      content\n    }\n  }\n"], ["\n  mutation WriteComment($comment: WritingCommentPayload!) {\n    comment: writeComment(comment: $comment) {\n      id\n      author {\n        id\n        name\n        role\n      }\n      createdAt\n      updatedAt\n      content\n    }\n  }\n"])));
function write(values, client) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.mutate({
                        mutation: WRITE_COMMENT,
                        variables: {
                            comment: values,
                        },
                        update: function (cache, _a) {
                            var data = _a.data;
                            var comments = cache.readQuery({
                                query: GET_COMMENTS,
                                variables: { postId: values.post }
                            }).comments;
                            cache.writeQuery({
                                query: GET_COMMENTS,
                                variables: { postId: values.post },
                                data: { comments: comments.concat([data.comment]) },
                            });
                        }
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export default function CommentWriter(props) {
    var content = props.content, submitButtonText = props.submitButtonText, postId = props.postId, onCancel = props.onCancel;
    var submit = props.onSubmit || write;
    return (React.createElement(Query, { query: GET_USER }, function (_a) {
        var loading = _a.loading, error = _a.error, data = _a.data, client = _a.client;
        if (loading)
            return React.createElement(Loading, null);
        if (error)
            return React.createElement(Error, { error: error });
        if (!data.currentUser) {
            return null;
        }
        return (React.createElement(Container, null,
            React.createElement(Formik, { initialValues: { content: content }, validate: function (values) {
                    var errors = {};
                    if (!values.content) {
                        errors.content = '내용을 입력해야 합니다.';
                    }
                    return errors;
                }, onSubmit: function (values, actions) {
                    submit(__assign({}, values, { post: postId, author: data.currentUser.id }), client).then(function () {
                        actions.setSubmitting(false);
                        if (!content) { // 쓰기 모드라면
                            actions.resetForm();
                        }
                    }, function (err) {
                        actions.setSubmitting(false);
                        actions.setErrors(transformErrorToObject(err));
                    });
                } }, function (_a) {
                var isSubmitting = _a.isSubmitting;
                return (React.createElement(Form, null,
                    React.createElement("ul", null,
                        React.createElement("li", { className: "content" },
                            React.createElement(Field, { component: "textarea", name: "content" })),
                        onCancel
                            ? (React.createElement("li", { className: "button-2" },
                                React.createElement("button", { className: "write", type: "submit", disabled: isSubmitting }, submitButtonText),
                                React.createElement("button", { className: "cancel", onClick: onCancel }, "\uCDE8\uC18C")))
                            : (React.createElement("li", { className: "button" },
                                React.createElement("button", { className: "write", type: "submit", disabled: isSubmitting }, submitButtonText)))),
                    React.createElement(ErrorMessage, { name: "content", render: function (msg) { return React.createElement("div", { className: "error" }, msg); } })));
            })));
    }));
}
CommentWriter.defaultProps = {
    content: '',
    submitButtonText: '쓰기',
};
var templateObject_1, templateObject_2, templateObject_3;
